import React from "react";

const StatusMessage = ({ tone = "info", title, children }) => (
  <div className={`feature-forecasting-alert feature-forecasting-alert--${tone}`}>
    {title && <strong>{title}</strong>}
    {children && <span>{children}</span>}
  </div>
);

export default StatusMessage;
